window.NotificationCenterAPIV2 = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.NotificationCenterServersV2);

    self.getFWWNotificationSettings = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/notifications/FWW_ALERT', 'GET')
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.saveFWWNotificationSettings = function (brandId, settingsData) {
        var defer = $q.defer();

        _protected
            .request('brands/' + brandId + '/settings/notifications/FWW_ALERT', 'PUT', settingsData)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });


        return defer.promise;
    };

    self.getNotificationsSettings = function (brandId, type) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/settings/notifications/' + type, 'GET')
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getCoreHrNotificationsSettings = function (brandId) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/core_hr_notification_settings', 'GET')
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getNotificationsUsers = function (brandId, params) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/users/notifications', 'GET', params)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateNotificationsUsers = function (brandId, type, payload) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/settings/notifications/' + type, 'PUT', payload)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };


    self.updateCoreHrNotificationsSettings = function (brandId, payload) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/core_hr_notification_settings', 'PUT', payload)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };


    self.getLeaveOfAbsenceNotificationSettings = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/notifications/loa/settings', 'GET')
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateLeaveOfAbsenceNotificationSettings = function (brandId, payload) {
        var defer = $q.defer();

        _protected
            .request('brands/' + brandId + '/notifications/loa/settings', 'PUT', payload)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.loadSocialReferralNotificationsSettings = function(brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/notifications/social_referral/settings', 'GET')

            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateSocialReferralNotificationsSettings = function(brandId , notificationSettings) {

        var defer = $q.defer();

        _protected
            .request('brands/' + brandId + '/notifications/social_referral/settings', 'PUT', notificationSettings)
            .then(function (response) {
                if (response.status === 200 && response.data ) {
                    defer.resolve(response.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;

    };

    self.getManageEmailsContentSettings = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/settings', 'GET').then(function (res) {
            if (res.status === 200 && res.data) {
                var result = res.data.data || {};
                defer.resolve(result);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    })[0];

    self.getEmailSmartFields = function (brandId, emailId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/emails/' + emailId + '/smart_fields', 'GET').then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                var smartFields = res.data.data.smart_fields || [];
                defer.resolve(smartFields);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.getEmailLayoutSettings = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/layout_settings', 'GET').then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.saveEmailLayoutSettings = function (brandId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/layout_settings', 'PUT', payload).then(function (res) {
            if (res.status === 200 && res.data ) {
                defer.resolve(res.data);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.getEmailsList = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/emails', 'GET').then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                defer.resolve(res.data.data.emails);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.getEmailData = function (brandId, emailId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/emails/' + emailId + '/content_settings', 'GET').then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.saveEmailData = function (brandId, emailId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/emails/' + emailId + '/content_settings', 'PUT', payload).then(function (res) {
            if (res.status === 200 && res.data && res.data) {
                defer.resolve(res);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.getEmailPreview = function (brandId, emailCode) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/preview_settings?email_code=' + emailCode, 'GET').then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.previewEmailLayout= function (brandId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/preview', 'POST', payload).then(function (res) {
            if (res.status === 200 && res.data && res.data.data ) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.getEmailPreviewTemplate = async (brandId, params) => {
        const response = await _protected.request(`brands/${brandId}/notification_templates/preview`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.previewEmailTemplateLayout = async (brandId, params) => {
        const response = await _protected.request(`brands/${brandId}/notification_templates/preview`, 'POST', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getSMSBalance = function(brandId, params){
        let defer = $q.defer();

        _protected.request('brands/'+brandId+'/sms_balances', 'GET', params)
            .then(function(res){
                if (res.status === 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.handleSendEmail = function (brandId, emailId, isEnabled) {
        var defer = $q.defer();
        var status = isEnabled ? 'enable' : 'disable';

        _protected.request('brands/' + brandId + '/services/MANAGE_EMAIL_CONTENT/emails/' + emailId + '/' + status, 'PUT')
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getMinorWorkPermitSettings = async (brandId) => {
        try {
            const res = await _protected.request(`brands/${brandId}/minor_work_notification_settings`, 'GET');
            if (res?.data?.data && res.status === 200) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (error) {
            throw error;
        }
    };

    self.updateMinorWorkPermitSettings = async (brandId, payload) => {
        try {
            const response = await _protected.request(`brands/${brandId}/minor_work_notification_settings`, 'PUT', payload);
            if (response?.data?.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (error) {
            throw error;
        }
    };
});
